export default "__VITE_ASSET__9ri3q_4l__"